
export class SalesTargetModel {
  sales: number = 0;
  target: number = 0;
  percentage: number = 0;

  constructor() {
    this.sales = 0;
    this.target = 0;
    this.percentage = 0;
  }
}

export class BasicInfoModel {
  currentMonth: string = "";
  totalShops: number = 0;
  totalScores: number = 0;
  accumulatedTarget: number = 0;
  salesTarget: SalesTargetModel = new SalesTargetModel();
  shortage: number = 0;

  constructor() {
    this.currentMonth = "";
    this.totalShops = 0;
    this.totalScores = 0;
    this.accumulatedTarget = 0;
    this.salesTarget = new SalesTargetModel();
    this.shortage = 0;
  }
}

export class CustomerScoreModel {
  customerCode: string = "";
  customerName: string = "";
  employee: string = "";
  targetScore: number = 0;
  salesScore: number = 0;
  totalScore: number = 0;

  constructor() {
    this.customerCode = "";
    this.customerName = "";
    this.employee = "";
    this.targetScore = 0;
    this.salesScore = 0;
    this.totalScore = 0;
  }
}

export class TargetDashboardModel {
  group: string = "";
  customerScore: CustomerScoreModel[] = [];

  constructor() {
    this.group = "";
    this.customerScore = [new CustomerScoreModel()];
  }
}